export const META_ONBOARDING_COMPLETED = 'onBoardingCompleted';
